module.exports = __webpack_public_path__ + "img/filledVentilation.b1f5711a.svg";